<template>
    <div class="container">
        <div class="main">
            <div class="content">
                <div class="box-f">
                    <div v-if="type != 'SUGGEST'">
                        <div class="title-row">
                            <div class="title" v-if="item.postName">{{item.postName}}</div>
                        </div>
                        <div class="userinfo-row">
                            <userInfo :item="item" :isShowFollow="true" />
                            <span v-if="userId == item.addUserId" class="edit-link" @click="toEdit"><i class="el-icon-edit"></i>编辑</span>
                        </div>
                    </div>
                    <div v-else>
                        <div class="userinfo-row">
                            <userInfo :item="item" :isShowFollow="true" />
                            <span v-if="userId == item.addUserId" class="edit-link" @click="toEdit"><i class="el-icon-edit"></i>编辑</span>
                        </div>
                        <div class="title-row">
                            <div class="title" v-if="item.postName">{{item.postName}}</div>
                        </div>
                    </div>
                    <div v-if="item.postType==1||item.postType==2||item.postType==3||item.postType==4||item.postType==5" class="article-desc editor-content-view mar20">
                        <a href="javascript:;" class="talk-name" v-if="item.talkName" @click="toTalkPost(item.talkId)">{{ `#${item.talkName}#` }}</a>
                        {{item.content || item.postDescribe}}
                        <span v-if="item.postType==5">操作步骤：{{item.operStep}}</span>
                    </div>
                    <div v-else class="editor-content-view mar20">
                        <div id="editor-content-view" v-html="normalizedContent"  @click="handleContentClick">
                        </div>
                    </div>
                    <div v-if="(item.postType==1||item.postType==3||item.postType==4||item.postType==5)&&item.attachList&&item.attachList.length>0">
                        <div class="img-wrap">
                            <div v-for="(itemImg,index) in item.attachList" :key="index">
                                <el-image
                                style="width: 200px; height: 200px"
                                :src="itemImg.fileUrl"
                                fit="contain"
                                :preview-src-list="attachList"></el-image>
                            </div>
                        </div>
                    </div>
                    <div v-if="item.postType==2&&item.attachList&&item.attachList.length>0">
                        <!-- <div class="video-wrap" v-for="(videoItem,index) in item.attachList" :key="index">
                            <video :poster="posterUrl" controls :src="videoItem.fileUrl">
                                您的浏览器不支持 video 标签。
                            </video>
                        </div> -->
                        <div class="video-wrap">
                            <video :poster="item.coverUrl" controls :src="item.picUrl">
                                您的浏览器不支持 video 标签。
                            </video>
                        </div>
                    </div>
                    <div v-if="item.postType == 5">
                        <div v-if="item.expectResult">
                            <div class="mt-1 font-700">预期结果</div>
                            <div class="color-0e mt-1">{{item.expectResult}}</div>
                        </div>
                        <div v-if="item.actualResult">
                            <div class="mt-1 font-700">实际结果</div>
                            <div class="color-0e mt-1">{{item.actualResult}}</div>
                        </div>
                        <div v-if="item.otherResult">
                            <div class="mt-1 font-700">其他信息</div>
                            <div class="color-0e mt-1">{{item.otherResult}}</div>
                        </div>
                    </div>
                    <div class="article-card-bottom">
                        <div class="bottom-l">
                            <div class="article-viewcnt">
                                <span>{{item.addTime | datefmt('yyyy-MM-DD')}}</span>
                                <span>浏览 {{item.viewNum || 0}}</span>
                                <span v-if="type == 'SUGGEST' && item.suggestNum">编号:{{item.suggestNum || ''}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="type == 'SUGGEST'"  class="box-f mt-2">
                    <div>建议投票</div>
                    <div class="suggest-content" v-if="item.wantFlag == -1">
                        <div class="suggest-text" @click="setSuggestDoWant(1)">想要</div>
                        <div class="suggest-no" @click="setSuggestDoWant(0)">不想要</div>
                    </div>
                    <div class="suggest-content flex-set" v-else>
                        <el-progress :percentage="percentage" :show-text="false" color="#d01c1d" define-back-color="blue" :stroke-width="10" class="suggest-progress"></el-progress>
                        <div class="suggest-result">
                            <div class="suggest-result">
                                <div class="want">{{item.suggestWantNum}}({{percentage}}%)<span v-if="item.wantFlag == 1">想要</span><span v-if="item.wantFlag == 1" class="el-icon-check"></span></div>
                                <div class="nowant"><span v-if="item.wantFlag == 0" class="el-icon-check"></span>{{item.suggestNowantNum}}<span v-if="item.wantFlag == 0">({{percentage2}}%)不想要</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="article-img color-6">
                        {{item.wantTotalNum}}人已参与
                    </div>
                </div>
                <div v-if="type == 'FEEDBACK'" class="box-f mt-2">
                    <div class="box-feedback">
                        <div class="mb-2">问题进度</div>
                        <el-steps :active="activefeedback" finish-status="success" >
                            <el-step title="问题创建"></el-step>
                            <el-step title="已立项"></el-step>
                            <el-step title="开发中"></el-step>
                            <el-step title="已优化"></el-step>
                        </el-steps>
                    </div>
                    <div class="article-img color-6">
                        {{item.wantTotalNum}}人已参与
                    </div>
                </div>
                <div class="comment-wrap box-f mt-2" v-if="commentList.length>0">
                    <div class="ub ub-pj">
                        <div>
                            <div class="comment-title" v-if="type == 'QUESTION'">
                                全部回答 <span>{{totalComment}}</span>
                            </div>
                            <div class="comment-title" v-else>
                                全部评论 <span>{{item.discussNum}}</span>
                            </div>
                        </div>
                        <div class="questions-wrap" v-if="item.categoryScene == 'SUGGEST' || item.categoryScene == 'QUESTION'|| item.categoryScene == 'FEEDBACK'">
                            <span :class="[sortType==2?'active':'']" @click="toQuestionSort(2)">热门</span>
                            <span :class="[sortType==1?'active':'']" @click="toQuestionSort(1)">最新</span>
                        </div>
                    </div>
                    <div v-for="(item,index) in commentList" :key="index">
                        <commentList :className="index == commentList.length-1 ? 'last' :''" :item="item" :type="type" @toComment="toCommentReply" @getComment="getCommentList"/>
                        <div v-if="item.childList" class="comment-reply">
                            <div v-for="(itemChild,_index) in item.childList" :key="_index">
                                <commentList :className="index == commentList.length-1 ? 'last' :''" :item="itemChild" @toComment="toCommentReply" @getComment="getCommentList" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="id && type != 'QUESTION'" class="comment-fixed" v-sticky-bottom="{ sentinel: '.comment-wrap' }">
                    <div class="comment-input" @click="toPublic">
                        <svg class="comment-icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                        <span class="placeholder-text">{{ userId ? '说说你的想法...' : '登录后才可评论' }}</span>
                    </div>
                    <div class="right-operate">
                        <div class="article-num" @click.stop="toPublic">
                            <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
                            <span>{{item.discussNum}}</span>
                        </div>
                        <div class="article-num" :class="{active: item.isLike==1}" v-if="type != 'FEEDBACK'" @click.stop="isLikeOrCancel(item)">
                            <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3m7-2V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3H14z"/></svg>
                            <span>{{item.praiseNum || 0}}</span>
                        </div>
                        <div class="article-num" :class="{active: item.isCollect==1}" @click.stop="isCollect(item)">
                            <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26"/></svg>
                            <span>{{item.collectNum || 0}}</span>
                        </div>
                        <div class="article-num" @click.stop="doShare(item)">
                            <svg class="icon" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>
                        </div>
                        <div class="article-num meet-btn active" v-if="type == 'FEEDBACK' && item.meetFlag == 1">
                            <span>+1</span>
                            <span>我也遇到过</span>
                        </div>
                        <div class="article-num meet-btn" v-if="type == 'FEEDBACK' && item.meetFlag == 0" @click.stop="feedbackDoMeet(item)">
                            <span>+1</span>
                            <span>我也遇到过</span>
                        </div>
                    </div>
                </div>
                <div v-if="id && type == 'QUESTION'" class="question-fixed" @click="toPublicQustion">
                   写回答
                </div>
                <div class="comment-placeholder"></div>
            </div>
            <div class="aside">
                <userAside :id="item.userId" />
                <asideNews />
                <asideCircle />
            </div>
        </div>
        <el-dialog 
            :title="type == 'QUESTION' ? '回答' : '发表评论'" 
            :visible.sync="publicDialogVisible" 
            :before-close="handleClose" 
            top="32vh" 
            width="500px"
            append-to-body
            :modal-append-to-body="false"
            style="z-index: 99999;">
            <div class="public-dialog">
                <textarea v-model="commentCnt" :placeholder="placeholderText"></textarea>
                <div class="dialog-btn">
                    <span class="public-btn" @click="toComment">发布</span>
                </div>
            </div>
        </el-dialog>
        <el-dialog style="z-index: 9999999;" title="回答" :visible.sync="questionDialogVisible" width="1000px" append-to-body destroy-on-close :close-on-click-modal="false">
			<div class="dialog-wrap">
                <textarea v-model="contentQ" class="content1" placeholder="请写下你的回答......"></textarea>
                <UploadImg @uploadDelete="uploadDelete" @uploadSuccess="uploadSuccess"/>
                <div class="btns">
                    <a @click="questionDialogVisible=false" href="javascript:;">取消</a>
                    <a @click="publicClick" href="javascript:;" class="active">发布</a>
                </div>
			</div>
		</el-dialog>
    </div>
</template>
<script>
import UploadImg from '@/components/upload'
import asideNews from '@/components/aside/news'
import asideCircle from '@/components/aside/recommendCircle'
import userInfo from '@/components/userinfo/userinfo'
import commentList from '@/components/circle/commentList'
import userAside from '@/components/aside/userAside'
import qs from 'qs'
import { post, ajaxParam } from '@/units/request.js'
import '@/assets/css/rich.less'
export default {
    name: 'detail',
    components: {
        asideNews,
        asideCircle,
        userInfo,
        commentList,
        userAside,
        UploadImg
    },
    data() {
        return {
            datapicker: '',
            isLogin: false,
            publicDialogVisible: false,
            id: '',
            userId: '',
            item: {},
            commentCnt: '',
            parentDiscussId: 0,
            pageSize: 10,
            pageNum: 1,
            commentList: [],
            totalComment: 0,
            placeholderText: '友善评论,共建和谐社区',
            percentage: 0,
            percentage2: 0,
            activefeedback: 1,
            type: '',
            sortType: 1, // 1最新 2热门
            attachList: [],
            questionDialogVisible: false,
            uploadFileUrl: [],
            answerPic: '',
            contentQ: ''
        }
    },
    mounted() {
        this.userId = localStorage.getItem('userId') || ''
        this.id = this.$route.query.id
        this.type = this.$route.query.type
        this.getDetailById(true)
    },
    watch: {
        $route(to) {
            this.id = to.query.id
            this.type = to.query.type
            this.getDetailById(true)
        },
        uploadFileUrl(newVal){
            if(newVal.length>0){
                this.answerPic = newVal.join(',')
            }
        }
    },
    computed: {
        normalizedContent() {
            const html = String((this.item && this.item.content) || '')
            return html
                .replace(/<p[^>]*>(?:\s|&nbsp;|<br\s*\/?>|<span[^>]*>(?:\s|&nbsp;|<br\s*\/?>)*<\/span>|<strong>(?:\s|&nbsp;|<br\s*\/?>)*<\/strong>)*<\/p>/gi, '')
                .replace(/<br\s*\/?>\s*<\/p>/gi, '</p>')
                .replace(/\bBash\b/g, 'bash')
                .replace(/\\\s+/g, '\\\n')
                .trim()
        }
    },
    beforeDestroy() {
        localStorage.removeItem('previewInfo')
    },
    methods: {
        handleContentClick(e) {
            if (e.target.classList.contains('talk-name')) {
                // 这里可以拿到 talkId，建议把 talkId 作为 data- 属性写到 a 标签上
                const talkId = e.target.getAttribute('data-talkid')
                this.toTalkPost(talkId)
            }
        },
        toCommentReply(e) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            console.log(e)
            this.placeholderText = '正在回复 ' + e.item.discussUserName
            this.parentDiscussId = e.item.id
            this.publicDialogVisible = true

        },
        //发表评论
        async toComment() {
            let param = {
                postId: this.item.id,
                discussUserId: this.userId,
                content: this.commentCnt,
                parentDiscussId: this.parentDiscussId
            }
            ajaxParam(param)
            const res = await post('v1/circle/discussPost', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success(res.data.msg||'操作成功!')
                this.handleClose()
                this.getCommentList()
                this.getDetailById(true)
            } else {
                this.$message.error(res.data.msg)
            }
        },
        //获取评论列表
        async getCommentList() {
            let param = {
                postId: this.item.id,
                userId: this.userId,
                pageNum: this.pageNum,
                pageSize: this.pageSize,
                sortType:this.sortType,
                discussType:1
            }
            ajaxParam(param)
            let res = null
            if(this.type == 'QUESTION'){
                res = await post('v1/circle/answerList', qs.stringify(param))
            }else{
                res = await post('v1/circle/discussList', qs.stringify(param))
            }
            if (res.data.code == 200) {
                this.commentList = res.data.list
                this.totalComment = res.data.total
                console.log(this.commentList, 'this.commentListthis.commentList')
            } else {
                this.$message.error(res.data.msg)
            }
        },
        toQuestionSort(e){
            this.sortType = e
            this.commentList = []
            this.pageNum = 1
            this.getCommentList()
        },
        //根据id获取详情
        async getDetailById(isTrue) {
            if (this.id) {
                let param = {
                    postId: this.id,
                    userId: this.userId
                }
                ajaxParam(param)
                const res = await post('v1/circle/postInfo', qs.stringify(param))
                if (res.data.code == 200) {
                    this.$set(this, 'item', res.data.entity)
                    if((this.item.postType==1||this.item.postType==3||this.item.postType==4||this.item.postType==5) && this.item.attachList&&this.item.attachList.length>0){
                        this.attachList=this.item.attachList.map(res=>{
                            return res.fileUrl
                        })
                    }
                    if (isTrue) {
                        this.getCommentList()
                    }
                    if(this.type == 'SUGGEST'){
                        if(this.item.wantTotalNum == 0) {
                            this.percentage =0
                            this.percentage2 =0
                        } else {
                            this.percentage = Math.floor(Number(this.item.suggestWantNum)/Number(this.item.wantTotalNum) * 100) 
                            this.percentage2 = Math.floor(Number(this.item.suggestNowantNum)/Number(this.item.wantTotalNum) * 100)
                        }
                    }
                    this.activefeedback = this.item.feedbackStatus ? this.item.feedbackStatus : 0
                    const _item = { ...res.data.entity }
                    if (_item.talkName) {
                        this.$nextTick(() => {
                            const contentBox = document.getElementById('editor-content-view')
                            if (contentBox && contentBox.childNodes[0]) {
                                const newElement = document.createElement('a')
                                newElement.href = 'javascript:;'
                                newElement.setAttribute('class', 'talk-name')
                                newElement.setAttribute('data-talkid', _item.talkId)
                                newElement.innerText = `#${_item.talkName}#`
                                contentBox.childNodes[0].insertBefore(newElement, contentBox.childNodes[0].firstChild)
                            }
                        })
                    }
                } else {
                    this.$message.error(res.data.msg)
                }
            } else {
                const userinfo = localStorage.getItem('user') || '{}'
                const previewInfo = localStorage.getItem('previewInfo') || '{}'
                const _userinfo = JSON.parse(userinfo)
                _userinfo.userId = _userinfo.id
                const _previewInfo = JSON.parse(previewInfo)
                console.log(_userinfo, '_userinfo')
                const _item = { ..._userinfo, ..._previewInfo }
                _item.addTime = new Date().getTime()
                this.$set(this, 'item', _item)
                if (_item.talkName) {
                    this.$nextTick(() => {
                        const contentBox = document.getElementById('editor-content-view')
                        if (contentBox && contentBox.childNodes[0]) {
                            const newElement = document.createElement('a')
                            newElement.href = 'javascript:;'
                            newElement.setAttribute('class', 'talk-name')
                            newElement.setAttribute('data-talkid', _item.talkId)
                            newElement.innerText = `#${_item.talkName}#`
                            contentBox.childNodes[0].insertBefore(newElement, contentBox.childNodes[0].firstChild)
                        }
                    })
                }

            }

        },
        toPublic() {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            this.publicDialogVisible = true
        },
        toPublicQustion() {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            this.questionDialogVisible = true
        },
        uploadSuccess(e){
            this.uploadFileUrl = e.uploadFileList
        },
        uploadDelete(e){
            let a = []
            e.uploadFileList.forEach(item=>{
                a.push(item.response.entity.fileUrl)
            })
            this.uploadFileUrl = a
        },
        // 发布回答
        async publicClick(){
            if(!this.contentQ) {
                this.$message.error('请输入回答内容')
                return
            }
            let param = {
                postId: this.item.id,
                answerUserId: this.userId,
                content: this.contentQ,
                answerPic: this.answerPic
            }
            ajaxParam(param)
            const res = await post('v1/circle/saveAnswer', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success(res.data.msg||'操作成功!')
                this.questionDialogVisible = false
                this.getCommentList()
                this.getDetailById(true)
            } else {
                this.$message.error(res.data.msg)
            }
        },
        //点赞 取消点赞
        async isLikeOrCancel(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                postId: item.id,
                flag: item.isLike == 1 ? 0 : 1
            }
            ajaxParam(param)
            const res = await post('v1/circle/likePost', qs.stringify(param))
            if (res.data.code == 200) {
                if (item.isLike == 1) {
                    this.$message.success('取消点赞成功！')
                    item.praiseNum--
                    this.getCommentList()
                    this.getDetailById(true)
                } else {
                    this.$message.success('点赞成功！')
                    item.praiseNum++
                    this.getCommentList()
                    this.getDetailById(true)
                }
                item.isLike = item.isLike == 1 ? 0 : 1

            } else {
                this.$message.error(res.data.msg)
            }
        },
        // 遇到
        async feedbackDoMeet(item) {
          if (!this.userId) {
            this.$router.push({
              path: '/login'
            })
            return
          }
          let param = {
            meetUserId: item.discussUserId,
            postId: item.id,
          }
          ajaxParam(param)
          const res = await post('v1/circle/feedbackDoMeet', qs.stringify(param))
          if (res.data.code == 200) {
            this.$message.success('反馈成功！')
            this.getCommentList()
            this.getDetailById(true)
          } else {
            this.$message.error(res.data.msg)
          }
        },
        handleClose() {
            this.publicDialogVisible = false
            this.commentCnt = ''
            this.parentDiscussId = 0
            this.placeholderText = '友善评论,共建和谐社区'
        },
		toTalkPost(id) {
			this.$router.push({
				path: '/talkPostList?id='+id
			})
		},
		toEdit() {
			const typeMap = { 0: 'article', 1: 'trends', 2: 'video', 3: 'suggest', 4: 'question', 5: 'feedback' }
			const type = typeMap[this.item.postType] || 'article'
			this.$router.push({
				path: '/publicIndex',
				query: { type, id: this.item.id, mode: 'edit' }
			})
		},
        // 想要或者是不想要
        async setSuggestDoWant(state){
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                wantUserId: this.userId,
                postId: this.item.id,
                wantFlag: state
            }
            ajaxParam(param)
            const res = await post('v1/circle/suggestDoWant', qs.stringify(param))
            if (res.data.code == 200) {
                this.$message.success('建议成功！')
                this.getDetailById(true)
            } else {
                this.$message.error(res.data.msg)
            }
        },
        async isCollect(item) {
            if (!this.userId) {
                this.$router.push({
                    path: '/login'
                })
                return
            }
            let param = {
                userId: this.userId,
                postId: item.id,
                flag: item.isCollect == 1 ? 0 : 1
            }
            ajaxParam(param)
            const res = await post('v1/circle/collectPost', qs.stringify(param))
            if (res.data.code == 200) {
                if (item.isCollect == 1) {
                    this.$message.success('取消收藏成功！')
                    item.collectNum--
                } else {
                    this.$message.success('收藏成功！')
                    item.collectNum++
                }
                item.isCollect = item.isCollect == 1 ? 0 : 1
            } else {
                this.$message.error(res.data.msg)
            }
        },
        doShare(item) {
            const url = window.location.origin + '/detail?id=' + item.id + '&type=' + this.type
            const copyToClipboard = (text) => {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    return navigator.clipboard.writeText(text)
                }
                return new Promise((resolve, reject) => {
                    const textarea = document.createElement('textarea')
                    textarea.value = text
                    textarea.style.position = 'fixed'
                    textarea.style.top = '0'
                    textarea.style.left = '0'
                    textarea.style.opacity = '0'
                    document.body.appendChild(textarea)
                    textarea.focus()
                    textarea.select()
                    try {
                        const success = document.execCommand('copy')
                        document.body.removeChild(textarea)
                        if (success) {
                            resolve()
                        } else {
                            reject(new Error('execCommand copy failed'))
                        }
                    } catch (e) {
                        document.body.removeChild(textarea)
                        reject(e)
                    }
                })
            }
            copyToClipboard(url).then(() => {
                this.$message.success('链接已复制到剪贴板')
            }).catch(() => {
                this.$message({ message: '分享链接：' + url, type: 'info', duration: 5000 })
            })
        }
    }
}
</script>
<style lang="less" scoped>
.mar20 {
    margin-top: 12px;
}

.article-tags {
    display: flex;
    // border: 1px solid var(--color-border);
    margin-right: 15px;
    padding: 5px;

    // border-radius: 14px;
    .tags-icon {
        // width: 18px;
        // height: 18px;
        margin-right: 4px;
        background: #DD0515;
        border-radius: 14px;
        color: #fff;
        line-height: 18px;
        text-align: center;
    }

    .tags-name {
        font-size: 12px;
        color: var(--color-text);
    }
}

.main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    width: 1180px;
    margin: 20px auto;

    .content {
        flex: 1;
        .box-f{
            background: #fff;
            padding: 20px 30px 60px;
            border-radius: 10px;
            position: relative;
            font-size: 16px;
            .userinfo-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }
            .edit-link {
                flex-shrink: 0;
                margin-left: 12px;
                font-size: 13px;
                color: #8a8a8a;
                cursor: pointer;
                white-space: nowrap;
                user-select: none;
                transition: color .2s;
            }
            .edit-link:hover {
                color: #DD0515;
            }
            .edit-link i {
                margin-right: 3px;
                font-size: 12px;
            }
        }
        
        .title-row {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            margin: 24px 0 12px;
            
            .title {
                flex: 1;
                font-size: 26px;
                line-height: 1.4;
                min-width: 0;
            }
        }

        .title {
            font-size: 26px;
            line-height: 1.4;
        }

        .article-desc {
            line-height: 22px;
        }

        /deep/ .editor-content-view{
            border: 0;
            border-radius: 0;
            padding: 0;
            word-break: break-word;
            overflow-wrap: anywhere;
            max-width: 100%;
        }

        /deep/ .editor-content-view *{
            line-height: 1.65 !important;
            max-width: 100%;
            word-break: break-word;
            overflow-wrap: anywhere;
        }

        /deep/ #editor-content-view{
            font-size: 15px;
        }

        /deep/ .editor-content-view > :first-child{
            margin-top: 0;
        }
        /deep/ .editor-content-view > :last-child{
            margin-bottom: 0;
        }

        /deep/ .editor-content-view h1,
        /deep/ .editor-content-view h2,
        /deep/ .editor-content-view h3,
        /deep/ .editor-content-view h4,
        /deep/ .editor-content-view h5,
        /deep/ .editor-content-view h6{
            margin: 14px 0 8px !important;
            line-height: 1.35 !important;
            font-weight: 700;
        }
        /deep/ .editor-content-view h1{ font-size: 22px; }
        /deep/ .editor-content-view h2{ font-size: 18px; }
        /deep/ .editor-content-view h3{ font-size: 16px; }
        /deep/ .editor-content-view h4,
        /deep/ .editor-content-view h5,
        /deep/ .editor-content-view h6{ font-size: 15px; }

        /deep/ .editor-content-view p{
            margin: 0 0 8px !important;
        }
        /deep/ .editor-content-view ul,
        /deep/ .editor-content-view ol{
            margin: 0 0 8px !important;
            padding-left: 20px;
        }
        /deep/ .editor-content-view li{
            margin: 0 0 4px !important;
        }

        /deep/ .editor-content-view table{
            display: block;
            margin: 10px 0;
            padding: 0;
            border-collapse: collapse;
            width: 100%;
            max-width: 100%;
            overflow-x: auto;
        }
        /deep/ .editor-content-view tbody{
            display: table-row-group;
        }
        /deep/ .editor-content-view tr{
            display: table-row;
        }
        /deep/ .editor-content-view td,
        /deep/ .editor-content-view th{
            display: table-cell;
            border: 1px solid #ddd;
            padding: 8px 12px;
            vertical-align: top;
            font-size: 14px;
            line-height: 1.6 !important;
            color: #333;
            word-break: break-word;
        }
        /deep/ .editor-content-view th{
            background: #f5f5f5;
            font-weight: 600;
        }

        /deep/ .editor-content-view pre{
            margin: 0 0 8px !important;
            padding: 10px 12px;
            border: 1px solid rgba(50, 50, 51, .12);
            border-radius: 10px;
            background: #f6f7f8;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
        }
        /deep/ .editor-content-view code{
            font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
            font-size: 13px;
        }

        /deep/ .editor-content-view blockquote{
            margin: 8px 0 !important;
        }
        /deep/ .editor-content-view hr{
            margin: 14px 0 !important;
        }

        /deep/ img {
            max-width: 80% !important;
            max-height: 100% !important;
            object-fit: cover;
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            margin-top: 10px;
            border-radius: 10px;
        }

        img {
            max-width: 80% !important;
            max-height: 100% !important;
            object-fit: cover;
            display: flex;
            flex-wrap: wrap;
            margin-right: 10px;
            margin-top: 10px;
            border-radius: 10px;
        }

        .img-wrap {
            display: flex;
            flex-wrap: wrap;
        }

        .video-wrap {
            display: flex;
            width: 98%;
            margin-top: 20px;

            video {
            max-width: 100%;
            max-height: 600px;
            }
        }

        .article-img {
            margin-top: 8px;
            color: var(--color-text-opacity);
        }

        .article-card-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 12px 0;

            .bottom-l {
                display: flex;
                align-items: center;

                .article-viewcnt span {
                    margin-right: 15px;
                    color: var(--color-text-opacity);
                }
            }
        }

        .comment-title {
            padding: 10px 0 20px;
            font-weight: bold;
        }

        .comment-reply {
            margin:12px 0;
            padding-left: 30px;
        }

        .comment-fixed {
            display: flex;
            align-items: center;
            gap: 16px;
            position: relative;
            z-index: 1001;
            width: 100%;
            bottom: auto;
            left: auto;
            margin-top: 20px;
            height: 68px;
            padding: 12px 30px;
            box-sizing: border-box;
            border-radius: 16px 16px 0 0;
            border: 1px solid rgba(50, 50, 51, .06);
            border-bottom: 0;
            box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.06);
            background: #fff;

            &.is-fixed {
                position: fixed;
                bottom: 0;
                border-radius: 16px 16px 0 0;
            }

            &.is-static {
                position: relative;
                width: 100%;
                bottom: auto;
                left: auto;
                border-radius: 16px;
                box-shadow: 0 -8px 30px rgba(0, 0, 0, 0.06);
            }

            .comment-input {
                display: flex;
                align-items: center;
                height: 44px;
                padding: 0 16px;
                border-radius: 24px;
                background: #F5F6F8;
                border: 1px solid transparent;
                flex: 1;
                cursor: pointer;
                min-width: 0;
                transition: background 0.2s ease, border-color 0.2s ease;

                &:hover {
                    border-color: rgba(50, 50, 51, .12);
                    background: #F0F1F4;
                }

                .comment-icon {
                    width: 18px;
                    height: 18px;
                    margin-right: 8px;
                    flex-shrink: 0;
                    color: var(--color-text-opacity);
                    opacity: 0.6;
                }

                .placeholder-text {
                    font-size: 14px;
                    color: var(--color-text-opacity);
                    opacity: 0.7;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
            }

            .right-operate {
                display: flex;
                align-items: center;
                gap: 20px;
                flex-shrink: 0;

                .article-num {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    color: var(--color-text-opacity);
                    cursor: pointer;
                    flex-shrink: 0;
                    transition: opacity 0.2s ease;

                    &:hover {
                        opacity: 0.85;
                    }

                    .icon {
                        width: 18px;
                        height: 18px;
                        flex-shrink: 0;
                        opacity: .6;
                        color: currentColor;
                    }

                    span {
                        font-size: 12px;
                        line-height: 1;
                        flex-shrink: 0;
                    }

                    &.active {
                        color: #DD0515;
                        .icon {
                            opacity: 1;
                            fill: #DD0515;
                            stroke: #DD0515;
                        }
                    }

                    &.meet-btn {
                        height: 36px;
                        padding: 0 14px;
                        border-radius: 18px;
                        background: #F5F6F8;

                        span { opacity: 1; }
                        span:first-child { margin-right: 6px; }

                        &.active {
                            background: #DD0515;
                            color: #fff;
                            span { color: #fff; }
                        }

                        &:hover {
                            background: #F0F1F4;
                            &.active { background: #b8141a; }
                        }
                    }
                }
            }
        }
        .comment-placeholder {
            height: 68px;
            margin-top: 20px;
            display: none;
        }
        .comment-fixed.is-fixed + .comment-placeholder {
            display: block;
        }

        .question-fixed{
            position: fixed;
            z-index: 1001;
            width: 200px;
            margin: auto;
            text-align: center;
            bottom: 20px;
            left: 40%;
            // right: 0;
            height: 40px;
            line-height: 40px;
            border-radius: 26px;
            color: #fff;
            box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.12);
            background: red;
            cursor: pointer;
        }
    }

    .aside {
        width: 300px;
        margin-left: 20px;
    }
    .article-img {
        margin-top: 8px;
    }

    .suggest-content{
        width: 100%;
        display: flex;
        margin-top: 20px;
        justify-content: space-between;
        .suggest-text,.suggest-no{
            width:322px;
            height: 38px;
            text-align: center;
            line-height: 38px;
            border: 1px solid #c6bfbf;
            color: #c6bfbf;
            border-radius: 15px;
        }
        .suggest-text{
            border: 1px solid #eb7979;
            color: #eb7979;
        }
        .suggest-progress{
            width: 100%;
            border: none;
        }
    }
    .flex-set{
        flex-direction: column;
        align-items: center;
        .suggest-result{
            width: 100%;
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            .want{
                color: #d01c1d;
            }
            .nowant{    
                color: #6575b4;
            }
        }
    }

}

/deep/ .el-dialog {
    border-radius: 10px;
}

/deep/ .el-dialog__wrapper {
    z-index: 99999 !important;
}

/deep/ .v-modal {
    z-index: 99998 !important;
}

.public-dialog {
    display: flex;
    flex-direction: column;

    textarea {
        height: 100px;
        background: #f6f7f8;
        padding: 10px;
        border-radius: 10px;
        border: none;
        line-height: 24px;
        box-sizing: border-box;
    }

    .dialog-btn {
        display: flex;
        justify-content: flex-end;

        .public-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 68px;
            height: 30px;
            margin-top: 20px;
            background: #DD0515;
            border-radius: 16px;
            color: #fff;
            cursor: pointer;
        }
    }

}

:deep .el-dialog__body {
    padding-top: 10px;
}
.suggest-progress{
    :deep .el-progress-bar__outer{
        background: #6575b4;
    }
}
.article-num {
    display: flex;
    align-items: center;
    margin-right: 25px;

    img {
        width: 18px;
        height: 18px;
        margin-right: 4px;
    }

    span {
        opacity: .6;
        font-size: 12px;
    }
    .plus-one{
                    width: 14px;
                    height: 14px;
                    border-radius: 50%;
                    border: 1px solid #666;
                    text-align: center;
                    line-height: 12px;
                    span{
                        font-size: 10px;
                    }
                }
                &.active{
                    color: #DD0515;
                    .plus-one{
                        border-color: #DD0515;
                        color: #DD0515;
                    }
                }
    
}
.box-feedback{
    padding: 30px;
    :deep .el-step {
    /* 步骤条连接线颜色 */
    .el-step__line {
        background-color: #999 !important;
    }
    /* 步骤图标和文字颜色（未完成状态） */
    .el-step__head {
        color: #999;
        border-color: #999;
    }

    /* 当前进行中的步骤颜色 */
    .el-step__head.is-process {
        color: #999 !important;
        border-color: #999 !important;
    }

    /* 已完成步骤的颜色 */
    .el-step__head.is-success {
        color: #ff5a5f !important;
        border-color: #ff5a5f !important;
        .el-step__line {
            background: linear-gradient(
                to right,
                #ff5a5f 0%,
                #ff5a5f 50%,
                #e4e7ed 50%,
                #e4e7ed 100%
            ) !important;
            height: 2px !important;
            border-radius: 1px;
        }
    }

    /* 步骤标题颜色 */
    .el-step__title {
        color: #666;
        &.is-process {
        color: #999 !important;
        }
        &.is-success {
        color: #ff5a5f !important;
        }
    }
    }
}
.questions-wrap{
    display: flex;
    align-items: center;
    width: 120px;
    height: 28px;
    background: #c4c4c4;
    border-radius: 4px;
    justify-content: space-around;
    z-index: 20;
    color: #fff;
    span{
        display: block;
        width: 100%;
        height: 28px;
        border-radius: 4px;
        text-align: center;
        line-height: 28px;
        cursor: pointer;
        font-size: 12px;
    }
    span.active{
        background: #ff5a5f;
    }
}
.content1{
    width: 100%;
    height: 160px;
    margin-bottom: 15px;
    padding: 10px;
    border-color: #DBDCDC;
    box-sizing: border-box;
    border-radius: 4px;
}
/deep/ .el-upload-list--picture-card .el-upload-list__item,
/deep/ .el-upload--picture-card {
    width: 70px;
    height: 70px;
    line-height: 70px;
}

.btns{
    display: flex;
    justify-content: space-between;
    a{
        display: block;
        width: 45%;
        height: 34px;
        margin-left: 15px;
        background: rgba(50,50,50,.1);
        border-radius: 16px;
        line-height: 34px;
        text-align: center;
    }
    a:hover, a.active{
        background: #DD0515;
        color: #fff;
    }
}
.icon-share{
    opacity: .6;
}
</style>